// Cookie / Terms bar (Oct 2026). Non-blocking: guests keep playing while it
// shows. "Got it" hides it for good on this device.
import { useState } from "react";
import { Link } from "react-router-dom";

const KEY = "4xlc_cookie_ok";

function alreadyAccepted() {
  try { return window.localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export default function CookieBar() {
  const [hidden, setHidden] = useState(alreadyAccepted);
  if (hidden) return null;
  const accept = () => {
    try { window.localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setHidden(true);
  };
  return (
    <div className="cookie-bar" role="region" aria-label="Cookie notice" data-testid="cookie-bar">
      <p>
        We use cookies to keep you signed in and to improve the game. By playing or signing in,
        you agree to our <Link to="/terms">Terms</Link> and <Link to="/privacy">Privacy Policy</Link>.
      </p>
      <button type="button" className="cookie-bar-btn" onClick={accept} data-testid="cookie-bar-ok">
        Got it
      </button>
    </div>
  );
}
